import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import {CanDeactivateDialogComponent} from './can-deactivate-dialog/can-deactivate-dialog.component';


@Injectable()
export class DeactivationDialogService {

  constructor(private dialog: MatDialog) {

  }

  confirm(data?: string | Object): Observable<boolean> {
    const dialog = this.dialog.open(CanDeactivateDialogComponent, {
      width: '500px',
      data: (typeof data === 'string') ?  {message: data} : data
    });
    return dialog.afterClosed();
  }

  getOpenDialogsLength() {
    if (this.dialog.openDialogs.find(dialog => dialog.id == 'platform-picker-dialog')) {
      return this.dialog.openDialogs.length - 1;
    }
    return this.dialog.openDialogs.length;
  }
}
